import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import './NoSpecialPromotion.scss'

class NoSpecialPromotion extends React.Component {
  render() {
    const { intl } = this.props
    const label = intl.formatMessage({
      id: 'page.giveawayPromotionOther.promotionClosed.heroTitle',
    })

    return (
      <div>
        <Helmet>
          <title>{label}</title>
        </Helmet>
        <div className="container text-justify">
          <h2 className="no-promotion-error-code">
            <FormattedMessage id="page.giveawayPromotionOther.promotionClosed.heroTitle" />
          </h2>
          <h4>
            <FormattedMessage id="page.giveawayPromotionOther.promotionClosed.description" />
          </h4>
          <p>
            <FormattedMessage id="page.giveawayPromotionOther.promotionClosed.note" />
            <br />
            <Link className="redirect" to="/">
              <i>
                <FormattedMessage id="error.global.clickHere" />{' '}
              </i>
            </Link>
            <FormattedMessage id="error.global.toReturnHome" />
          </p>
        </div>
      </div>
    )
  }
}

export default injectIntl(NoSpecialPromotion)
